import styles from './Backdrop.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DialogDismiss } from '@ariakit/react';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';

const Backdrop = forwardRef(
  (
    {
      animated = false,
      className = null,
      dismissAriaLabel = 'Dialogfenster schließen',
      hasCloseButton = false,
      isTransparent = true,
      onClick = () => {},
      store,
      ...props
    },
    ref,
  ) => (
    <div
      className={classNames(
        styles.container,
        { [styles.isTransparent]: isTransparent, [styles.animated]: animated },
        className,
      )}
      onClick={onClick}
      ref={ref}
      role="presentation"
      {...props}
    >
      {hasCloseButton && (
        <DialogDismiss
          aria-label={dismissAriaLabel}
          className={styles.closeButton}
        >
          <FontAwesomeProIcon icon="times" role="presentation" />
        </DialogDismiss>
      )}
    </div>
  ),
);

Backdrop.propTypes = {
  animated: PropTypes.bool,
  className: PropTypes.string,
  dismissAriaLabel: PropTypes.string,
  hasCloseButton: PropTypes.bool,
  isTransparent: PropTypes.bool,
  onClick: PropTypes.func,
};

Backdrop.displayName = 'Backdrop';

export default Backdrop;
